<div class="flex flex-wrap -mx-2">
  <div class="flex-none w-1/2 px-2">
    <mat-form-field id="cron-job-frequency" [subscriptSizing]="'fixed'" appearance="outline" class="w-full">
      <mat-label>Frequency:</mat-label>
      <mat-select name="cron-job-frequency" [formControl]="selectedFrequencyControl" #siSelectRef="matSelect">
        <mat-option [value]="frequencyTypesEnum.DAILY">Daily</mat-option>
        <mat-option [value]="frequencyTypesEnum.WEEKLY">Weekly</mat-option>
        <mat-option [value]="frequencyTypesEnum.MONTHLY">Monthly</mat-option>
      </mat-select>
      <fa-icon matSuffix aria-hidden="true" class="si-icon si-select-arrow" [class.si-select-arrow--open]="siSelectRef.panelOpen" [icon]="['fal', 'chevron-down']"></fa-icon>
    </mat-form-field>
  </div>
  <div class="flex-none w-1/2 px-2">
    <div *ngIf="selectedFrequencyControl.value" [formGroup]="form">
      <div class="inline-block w-90 mr-2">
        <mat-form-field [subscriptSizing]="'fixed'" appearance="outline" class="w-full">
          <mat-label>Timing</mat-label>
          <mat-select [formControlName]="formKeysEnum.Hours" #siSelectRef2="matSelect">
            <mat-option *ngFor="let hour of hoursOptions" [value]="hour">{{ hour }}:00</mat-option>
          </mat-select>
          <fa-icon matSuffix aria-hidden="true" class="si-icon si-select-arrow" [class.si-select-arrow--open]="siSelectRef2.panelOpen" [icon]="['fal', 'chevron-down']"></fa-icon>
        </mat-form-field>
      </div>

      <div class="inline-block w-90">
        <mat-form-field [subscriptSizing]="'fixed'" appearance="outline" class="w-full">
          <mat-select [formControlName]="formKeysEnum.Ampm" #siSelectRef3="matSelect">
            <mat-option *ngFor="let ampm of ampmOptions" [value]="ampm">{{ ampm }}</mat-option>
          </mat-select>
          <fa-icon matSuffix aria-hidden="true" class="si-icon si-select-arrow" [class.si-select-arrow--open]="siSelectRef3.panelOpen" [icon]="['fal', 'chevron-down']"></fa-icon>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
<div class="flex flex-wrap -mx-2" [formGroup]="form">
  <div class="flex-none w-1/2 px-2" *ngIf="selectedFrequencyControl.value === frequencyTypesEnum.MONTHLY">
    <div>
      on day
      <div class="inline-block w-90">
        <mat-form-field [subscriptSizing]="'fixed'" appearance="outline" class="w-full">
          <mat-select [formControlName]="formKeysEnum.MonthDay" #siSelectRef4="matSelect">
            <mat-option *ngFor="let day of monthDaysOptions" [value]="day">{{ day }}</mat-option>
          </mat-select>
          <fa-icon matSuffix aria-hidden="true" class="si-icon si-select-arrow" [class.si-select-arrow--open]="siSelectRef4.panelOpen" [icon]="['fal', 'chevron-down']"></fa-icon>
        </mat-form-field>
      </div>
      of the month
    </div>
  </div>
  <div class="flex-none w-1/3 px-2" *ngIf="selectedFrequencyControl.value === frequencyTypesEnum.WEEKLY">
    <div>
      on
      <div class="inline-block w-150">
        <mat-form-field [subscriptSizing]="'fixed'" appearance="outline" class="w-full">
          <mat-select [formControlName]="formKeysEnum.WeekDay" #siSelectRef5="matSelect">
            <mat-option *ngFor="let item of weekDaysOptions" [value]="item.value">{{ item.description }}</mat-option>
          </mat-select>
          <fa-icon matSuffix aria-hidden="true" class="si-icon si-select-arrow" [class.si-select-arrow--open]="siSelectRef5.panelOpen" [icon]="['fal', 'chevron-down']"></fa-icon>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
